import * as React from "react";
import { formatBreadcrumbTitle } from "../helpers/format_breadcrumb_title";

export type BreadcrumbNavigationItem = {
  path: string;
  title: string;
  position: number;
};

export type BreadcrumbsProps = {
  navigationItems: BreadcrumbNavigationItem[];
};

export const Breadcrumbs = React.memo(
  ({ navigationItems }: BreadcrumbsProps): JSX.Element => (
    <div>
      <div className="breadcrumb">
        <a href="/">Úvod</a>
        {navigationItems
          .sort((a, b) => a.position - b.position)
          .map((navigationItem) => (
            <a href={navigationItem.path} key={navigationItem.path}>
              {formatBreadcrumbTitle(navigationItem.title)}
            </a>
          ))}
      </div>
    </div>
  )
);
